/**
 * i18n composable wrapping FormatJS useIntl() via react-intl.
 * This is the default (React) version. Vue version is useI18n.vue.ts.
 */

import { useIntl } from "react-intl";
import {
  numberFormats,
  dateFormats,
  type NumberFormatPreset,
  type DateFormatPreset
} from "./formats";

export function useI18n() {
  const intl = useIntl();

  function t(key: string, countOrValues?: number | Record<string, unknown>): string {
    const values =
      typeof countOrValues === "number"
        ? { count: countOrValues, n: countOrValues }
        : countOrValues;
    return intl.formatMessage({ id: key }, values as any);
  }

  function n(number: number | string, type: NumberFormatPreset): string {
    const floatNumber = Number.parseFloat(String(number));
    if (Number.isNaN(floatNumber)) return "";
    const localeFormats = (numberFormats[intl.locale] ?? numberFormats["en-US"])!;
    const opts = localeFormats[type];
    return intl.formatNumber(floatNumber, opts as any).replace(/CAD\s/g, "$");
  }

  function d(value: Date | number | string, preset: DateFormatPreset): string {
    const opts = dateFormats[preset];
    return intl.formatDate(value, opts);
  }

  return { t, n, d, intl };
}
